<template>
  <div class="py-4">
    <div class="d-flex flex-row align-items-start">
      <div class="w-25">
        <img v-if="citySealUrl" :src="citySealUrl" class="seal-logo" />
      </div>
      <div class="w-50 text-center fw-bold">
        <div>
          {{ city.formalName }}
        </div>
        <div>
          {{ city.officeTitle }}
        </div>
        <div>
          {{ city.townHallAddress }}
        </div>
        <div>
          {{ city.name }}, {{ city.state }}
        </div>
      </div>
      <div class="w-25">&nbsp;</div>
    </div>
    <div class="mt-4 text-center">
      {{ new Date().toLocaleDateString() }}
    </div>
    <div class="mt-4 d-flex flex-row align-items-start">
      <div class="me-2">To:</div>
      <div>
        <div v-for="owner in model.ownersFormatted" :key="owner">
          {{ owner }}
        </div>
        <div>{{ model.addressFormatted }}</div>
        <div>{{ city.name }}, ME</div>
      </div>
    </div>
    <div class="my-4 d-flex flex-row align-items-start">
      <div class="me-2">Re:</div>
      <div>
        <div>
          {{ city.violationLetterTitle || model.addressFormatted }}
        </div>
        <div v-if="city.violationLetterSubtitle">
          {{ city.violationLetterSubtitle }}
        </div>
      </div>
    </div>
    <div class="mt-4 pt-4 border-top">
      <p style="word-wrap: break-word">
        We have reason to believe that your property, at <b>{{ model.addressFormatted }}</b>, is listed as a short-term
        rental. However, this property is not currently licensed under our Short-Term Rental Ordinance.
      </p>
      <p class="mb-4" style="word-wrap: break-word">
        Please contact us as soon as possible to rectify this situation.  If we do not hear from you and continue to
        see your property advertised for short term rental, we will pursue legal action for this violation.
      </p>
      <p class="mb-4" style="word-wrap: break-word">
        You can apply for a Short Term Rental Permit at
        <a href="https://app.govwell.com/cape-elizabeth" target="_blank">https://app.govwell.com/cape-elizabeth</a>.
      </p>
      <br/>
      <div>
        <div class="mb-4">
          Sincerely,
        </div>
        <div class="mb-4">
          Ben McDougal<br/>
          Code Enforcement Officer<br/>
          benjamin.mcdougal@capeelizabeth.gov<br/>
          207-799-1619<br/>
        </div>
        <div>
          Scott Havu<br/>
          Assistant Code Enforcement Officer<br/>
          scott.havu@capeelizabeth.gov<br/>
          207-799-1619<br/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {LetterContext} from "@/models/letterContext";

export default {
  props: {
    model: LetterContext,
    voluntary: Boolean
  },
  emits: ['ready'],
  mounted() {
    setTimeout(() => this.$emit('ready'), 500);
  },
  computed: {
    city() {
      return this.model.city;
    },
    citySealUrl() {
      return this.city.townSealUrl;
    },
    registrationLocation() {
      return `either in person at our municipal offices at ${this.city.townHallAddress}, or online at https://app.strenforcement.com/register/${this.model.cityId}`;
    }
  }
}
</script>
